<template>
    <div class="subscribe-page ac">
		<Header></Header>
		<div class="content mt100">
      <div class="phone-t por">
        <span class="code-num">09</span>
        <input class="input-block" v-model="mobile" type="" value="dmwdovWn4aLDq/Q=" name="mobile" :placeholder="$t('phone_number')">
      </div>
			<div class="item input-code mt10">
				<input class="input-block input-code1" style="padding-left: 20px;" v-model="valid_code" :placeholder="$t('OTP')" type="tel" maxlength="6" value="" />
				<div class="btn disable v-code fs15" v-if="codeText!=''&&codeText!='0s'">{{codeText}}</div>
				<div class="btn v-code fs15" v-if="codeText==''" @click="code()">{{$t('Get')}}</div>
				<div class="btn v-code fs15" v-if="codeText=='0s'" @click="code()">{{$t('RESEND')}}</div>
			</div>
			<div class="unsubscribe ">
				<button class="button active  fs40 btn-block mt30" @click="_loginAction">{{$t('loginCode')}}</button>
			</div>
		</div>
    <div class="modal login-modal" v-if="isShow2">
      <div class="modal-bg"></div>
      <div class="modal-content modal-content2">
        <img :src="dataPopup.image" />
        <div class="close ac" @click="getClose">x</div>
      </div>

    </div>
	</div>
</template>
<script>
import Header from '../components/HeaderLogin'
import Dialog from '../components/dialog'
export default {
    components:{
      Header,
      Dialog
    },
    data() {
        return {
        mobile:'',
        passwd:'123456',
        type:'day',
        is_register:'',
        isShow:false,
        isShow2:false,
        dataPopup:null,
        codeText:'',
        valid_code:'',

      }
    },
    created(){
      this.mobile = this.$route.query.mobile
      this.code()
    },
		methods: {
			// 计时
			countDown (miao,type){
				if(miao === 1){
					this.codeText ="0s";
					this.hlep = true;
					return;
				}
				miao--;
				this.codeText = miao + "s";
				clearInterval(this.timer)
				this.timer = setInterval(()=>{
					this.countDown(miao,type);
				},1000)
				if(miao==1){
					this.clickNum = true;
				}
			},
      code(){
      	let that = this;
      	if(that.mobile == ""){
      		that.$utils.alertText(that.$t('codeTips1'),60)
      		return;
      	}else{
      		that.getCode();
      	}
      },
			// 获取验证码
			getCode(){
				let that = this;
				var data = {
					'mobile':'09'+that.mobile
				}
				that.$api.post('login/otp',data,r =>{
          console.log(r)
          if(r.code==0){
            that.$utils.alertText(that.$t('codeTips2'),60)
            that.countDown(61,1);
          }

				})
			},
      _loginAction(){
        let that = this
        var data = {
					'mobile':'09'+that.mobile,
          'otp':that.valid_code,
				}
        if(that.valid_code == ""){
        	that.$utils.alertText(that.$t('codeTips3'),60)
        	return;
        }
				that.$api.post('login/otplogin',data,r =>{
          if(r.code==70001){
            console.log(2222)
            that.$utils.alertText(that.$t('codeTips3'),60)
          }else if(r.code==0){
            that.$router.push('/');
            that.valid_code = '';
            localStorage.setItem('token',r.data.token)
            localStorage.setItem('uuid',r.data.uuid)
            localStorage.setItem('mobile',r.data.mobile)
          }
				})
      },
		}
	}
</script>

<style>
  .code-num{position:absolute;left: calc(10% + 15px);top: 2px;height: 86px;line-height: 86px;font-size: 30px;padding: 0 10px;font-weight:700;}
	.input-block{border:1px solid #555;height: 90px;
    width: 80%;
    border-radius: 20px;
    padding: 0 20px;
    font-size: 30px;padding-left: 70px;}
    .input-code1{padding-left: 20px;}
	.radio-div{margin:40px 0 20px;}
	.radio{width:30px;height:30px;vertical-align: middle;margin: 0 10px 0 0;}
  .modal-content2{position:absolute;top:50%;left:50%;margin-top:-10px;border-radius:8px;margin-left: -45%;width: 90%;}
  .modal-content2 img{border-radius:20px;width:100%;}
  .close{background: rgb(255 255 255 / 20%);
    color: #fff;
    width: 80px;
    height: 80px;
    font-size: 47px;
    margin: 30px auto 0;
    border-radius: 100px;}
    .input-code{display:flex;width:80%;margin: 0 auto;}
    .mt10{margin-top:40px;}
    .v-code{border-radius:10px;background: #ff1d4f;
    color: #fff;width:270px;}
    .v-code.disable{opacity: .5;}
</style>



// WEBPACK FOOTER //
// src/page/code.vue